import { ErrorMessage } from "./NitAnalysisCard/components/ErrorMessage";
import { Analysis, Sample } from "../types";
import { DeviceType } from "../constants/deviceTypes";
import { isLabValidForAnalysis } from "../functions/isLabValidForAnalysis";
import { isM3StatusValidForSample } from "functions/isM3StatusValidForSample";

interface ErrorContainerProps {
    analysis?: Analysis;
    sample?: Sample;
    calibration?: boolean;
    connectionError?: boolean;
    grossNetError?: boolean;
    refWeightError?: boolean;
    analysisErrors: string[];
}

export function ErrorContainer({
    analysis,
    calibration,
    sample,
    connectionError,
    grossNetError,
    analysisErrors,
    refWeightError
}: Readonly<ErrorContainerProps>) {
    const invalidLabForAnalysis = sample ? !isLabValidForAnalysis(sample.lab) : false;
    const invalidM3StatusForSample = !isM3StatusValidForSample(sample?.m3StatusAnmodan);
    return (
        <>
            {sample?.completed &&
                <ErrorMessage>
                    Varning! ProvID är klarflaggat.
                </ErrorMessage>}
            {invalidM3StatusForSample &&
                <ErrorMessage>
                    Detta prov är avbrutet eller ersatt i M3.
                </ErrorMessage>}
            {invalidLabForAnalysis &&
                <ErrorMessage>
                    Detta prov ska inte analyseras på Labonsite.
                </ErrorMessage>}
            {!calibration && sample && analysis && analysis.deviceType === DeviceType.NIT &&
                <ErrorMessage>
                    Varning! Fel kalibrering vald.
                </ErrorMessage>}
            {connectionError &&
                <ErrorMessage>
                    Fel! Ingen kontakt med M3-databasen.
                </ErrorMessage>}
            {grossNetError &&
                <ErrorMessage>
                    Varning! Felaktiga brutto/netto värden angivna.
                </ErrorMessage>}
            {refWeightError &&
                <ErrorMessage>
                    Fel. Rymdvikt måste vara mellan 0 och 9999.9.
                </ErrorMessage>}
            {analysisErrors.map((message) =>
                <ErrorMessage key={message}>
                    {message}
                </ErrorMessage>)}
        </>
    );
}